import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../styles/variables';
import Cards from '../components/Cards';
import { useQuery } from '@apollo/client';
import { GET_CARDS } from '../features/queries';
import Loader from '../components/Shared/Loader';

const Main = () => {
  const { loading, error, data } = useQuery(GET_CARDS);

  return (
    <MainWr>{loading ? <Loader /> : error ? <div>ошибка</div> : <Cards data={data} />}</MainWr>
  );
};

const MainWr = styled.div`
  color: ${COLORS.black};
`;

export default Main;
